import { render } from "./TdmPreview.vue?vue&type=template&id=30173e58&scoped=true&ts=true"
import script from "./TdmPreview.vue?vue&type=script&lang=ts"
export * from "./TdmPreview.vue?vue&type=script&lang=ts"

import "./TdmPreview.vue?vue&type=style&index=0&id=30173e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30173e58"]])

export default __exports__